import * as R from 'ramda';
import { HttpClient, JSON_STRING } from '../../../../services/http/http-client';
import { BOOKING_URL, MODIFICATION_URL } from '../../../../services/common-urls';

export const LOCATION_STRING = 'location';
export const LOCATION_PAGE_STRING = 'location_page';

export const VenueService = {
  findVenues: (startRow, options) => HttpClient.post(BOOKING_URL, {
    section: LOCATION_STRING,
    action: LOCATION_PAGE_STRING,
    startrow: startRow
  }, options),
  searchVenues: ({
    search
  }, options) => HttpClient.post(BOOKING_URL, {
    section: 'location',
    action: 'search_location',
    search
  }, options),
  findVenueDetails: ({
    bookingLocationId
  }, options) => HttpClient.get(BOOKING_URL, {
    section: LOCATION_STRING,
    booking_location_id: bookingLocationId
  }, options),
  modifyVenueFeatures: ({
    kVal,
    value
  }) => HttpClient.modify(
    'booking_location_id',
    kVal,
    'feature',
    value,
    'booking_locations'
  ),
  findVenueGenres: ({
    booking_location_id
  }) => HttpClient.post(BOOKING_URL, {
    section: 'location',
    action: 'related_genres',
    booking_location_id,
    output: JSON_STRING
  }),
  removeVenueGenres: ({
    external_id,
    genre_id,
    external_table = 'booking_locations'
  }) => HttpClient.post(BOOKING_URL, {
    section: 'location',
    action: 'add_remove_genre',
    external_id,
    genre_id,
    external_table,
    output: JSON_STRING
  }),
  filterEvents: ({
    booking_location_id,
    artist_id,
    from_date,
    to_date,
    booking_status_id,
    promoter_id,
  }) => HttpClient.post(BOOKING_URL, {
    section: 'location',
    action: 'filter_artist_events',
    booking_location_id,
    artist_id,
    from_date,
    to_date,
    booking_status_id,
    promoter_id,
    output: JSON_STRING,
  }),
  searchLocation: ({
    location,
    city,
  }) => HttpClient.post(BOOKING_URL, {
    section: 'location',
    action: 'find_matched_location',
    output: JSON_STRING,
    location,
    city,
  }),
  createLocation: ({
    booking_location_name,
    city,
    country,
  }) => HttpClient.post(BOOKING_URL, {
    section: 'location',
    action: 'create_location',
    market_area: city,
    booking_location_name,
    city,
    country,
    market_area: city,
    output: JSON_STRING,
  }),
  linkLocation: ({
    booking_location_id
  }) => HttpClient.post(BOOKING_URL, {
    section: 'location',
    action: 'link_location',
    output: JSON_STRING,
    booking_location_id,
  }),
  checkCalendarDateRelation: ({
    booking_location_id
  }) => HttpClient.post(BOOKING_URL, {
    section: 'location',
    action: 'has_calendardate_relation',
    booking_location_id
  }).then(res => res.data),
  removeLocation: ({
    booking_location_id
  }) => HttpClient.post(BOOKING_URL, {
    section: 'location',
    action: 'remove_location',
    booking_location_id
  }).then(res => res.data),
}